import { withSvgIcon } from './withSvgIcon';

export const ExternalLink = withSvgIcon(
  <path
    fillRule="evenodd"
    clipRule="evenodd"
    d="M16.4871 7H14V5H19H20V6V11H18V8.31769L10.727 15.1866L9.27298 13.8134L16.4871 7ZM8 20C6.34315 20 5 18.6569 5 17V9C5 7.34315 6.34315 6 8 6L12 6V8L8 8C7.44772 8 7 8.44772 7 9L7 17C7 17.5523 7.44772 18 8 18H16C16.5523 18 17 17.5523 17 17V13H19V17C19 18.6569 17.6569 20 16 20H8Z"
    fill="currentColor"
  />,
  { viewBox: '0 0 24 24' },
);
